// extracted by mini-css-extract-plugin
var _1 = "eDnZQpZD";
var _2 = "X8TUfEpo";
var _3 = "X8TUfEpo";
var _4 = "qaOkOG4c";
var _5 = "qaOkOG4c";
export { _1 as "popup", _2 as "sticker-icon", _3 as "stickerIcon", _4 as "tag-list", _5 as "tagList" }
